import _ from 'lodash';
import { TFunction } from 'react-i18next';

export type SelectOptionProps = {
  labelKey?: string;
  labelAddonKey?: string;
  valueKey?: string;
  translationNamespace?: string;
}

export const normalizeCode = (value: string) => (value || '').replace(/\s+/g, '');

export const capitalizeWords = (value: string) => (value || '').replace(/(^|\s)\S/g, (char) => char.toUpperCase());

// Gets t from the caller: a hook here would run once per rendered select, and DataForm renders a varying number of them.
export const getSelectOptions = (list: any, props: SelectOptionProps, t: TFunction<'translation', undefined>) => {
  const { labelKey, valueKey, translationNamespace, labelAddonKey } = props;

  return _.map(list, (val) => {
    const isObject = typeof val === 'object';

    let label = isObject && labelKey ? val[labelKey] : null;
    const labelAddon = isObject && labelAddonKey ? val[labelAddonKey] : null;
    const value = isObject && valueKey ? val[valueKey] : val;

    if (label && labelAddon) {
      label = `${label} (${labelAddon})`;
    }

    return {
      label: label || t(`${translationNamespace}.${val.toLowerCase()}`),
      value: value
    };
  });
};